import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { createHygiene, updateHygiene } from '../../api/hygienes';
import { list as productList } from '../../api/products';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { ProductIdGroup } from '../../components/ProductIdGroup';
import { PlusIcon } from '../../icons/PlusIcon';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './hygienes.styl';
var HygienesDetailsModal = /** @class */ (function (_super) {
    __extends(HygienesDetailsModal, _super);
    function HygienesDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            subtitleInputError: false,
            contentInputError: false,
            colorInputError: false,
            typeInputError: false,
            linkedProductError: false,
            editorState: '',
            products: [],
        };
        _this.removeCount = 10;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
            if (name === 'subtitle') {
                _this.setState({ subtitleInputError: false });
            }
            if (name === 'colortitle') {
                _this.setState({ colorInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.onAddCombination = function () {
            var combinations = _this.state.linkedProductIds || [];
            if (combinations.length !== 0) {
                if (combinations[combinations.length - 1].length !== 0) {
                    combinations.push([]);
                    _this.setState({
                        linkedProductIds: combinations,
                    });
                }
            }
        };
        _this.onRemoveGroup = function (index) {
            var combinations = _this.state.linkedProductIds || [];
            combinations.splice(index, 1);
            _this.removeCount += 10;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        _this.onProductGroupChanged = function (index, group) {
            var combinations = _this.state.linkedProductIds || [];
            combinations[index] = group;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        return _this;
    }
    HygienesDetailsModal.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.hygiene) {
            var hygiene = this.props.hygiene;
            this.setState({
                editorState: hygiene.content || '',
                linkedProductIds: (hygiene === null || hygiene === void 0 ? void 0 : hygiene.linkedProductIds) || [[]],
            });
        }
        else {
            this.setState({
                linkedProductIds: [[]],
            });
        }
        productList().then(function (products) {
            _this.setState({
                products: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HygienesDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        var subtitle = elements.subtitle.value;
        var color = elements.color.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        if (subtitle.length === 0) {
            this.setState({ subtitleInputError: true });
            valid = false;
        }
        if (color.length === 0) {
            this.setState({ colorInputError: true });
            valid = false;
        }
        var html = this.editorStateRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ contentInputError: true });
            valid = false;
        }
        var ids = this.state.linkedProductIds;
        if (!ids || ids.length === 0) {
            this.setState({ linkedProductError: true });
            valid = false;
        }
        var flatList = '';
        ids === null || ids === void 0 ? void 0 : ids.forEach(function (group) {
            if (group.length !== 0) {
                if (group.length === 1 && group[0] === -10) {
                    // Do not add group with only the infected id selected
                }
                else {
                    if (flatList.length !== 0) {
                        flatList = flatList + ";";
                    }
                    flatList += group.join(',');
                }
            }
        });
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            subtitle: subtitle,
            color: color,
            content: html,
            linkedProductIds: flatList,
        };
        this.setState({ loading: true });
        if (this.props.hygiene) {
            request.id = this.props.hygiene.id;
            updateHygiene(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createHygiene(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    HygienesDetailsModal.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this, props = _b.props, state = _b.state;
        var i18n = props.store.i18n;
        var hygiene = props.hygiene;
        var loading = state.loading, editorState = state.editorState;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.hygienesAddView },
                React.createElement("p", { className: S.hygienesHeaderText }, hygiene ?
                    i18n.hygienesUpdateTitle
                    :
                        i18n.hygienesCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: hygiene === null || hygiene === void 0 ? void 0 : hygiene.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputSubtitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputSubtitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "subtitle", autoComplete: "subtitle", onInput: this.onChangeAction, placeholder: i18n.inputSubtitlePlaceholder, defaultValue: hygiene === null || hygiene === void 0 ? void 0 : hygiene.subtitle })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleColor),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitleColor),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "color", autoComplete: "color", onInput: this.onChangeAction, placeholder: "#000000", defaultValue: hygiene === null || hygiene === void 0 ? void 0 : hygiene.color })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.colorInputError ? 'inputErrorActive' : '') }, i18n.validationSelectError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.editorStateRef = editor; }, apiKey: getEditorKey(), initialValue: editorState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentInputError ? 'inputErrorActive' : '') }, i18n.validationContentError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputProductCombinations),
                        React.createElement("div", { className: S.modelCombination }, state.products &&
                            React.createElement(React.Fragment, null, (_a = this.state.linkedProductIds) === null || _a === void 0 ? void 0 : _a.map(function (productIds, index) { return (React.createElement(ProductIdGroup, { key: index * _this.removeCount, index: index, productIds: productIds, products: state.products || [], onRemoveGroup: _this.onRemoveGroup, onProductGroupChanged: _this.onProductGroupChanged })); }))),
                        React.createElement("div", { className: S.modelAddButtonWrapper },
                            React.createElement(Button, { className: "" + S.modelAddButton, type: "button", onClick: this.onAddCombination },
                                React.createElement(PlusIcon, null),
                                " ",
                                i18n.inputAddCombination)),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.linkedProductError ? 'inputErrorActive' : '') }, i18n.validationSelectError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.hygienesModalButton, type: "submit", spinner: loading }, hygiene ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.hygienesModalButton + " " + S.hygienesModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], HygienesDetailsModal.prototype, "onSubmit", null);
    HygienesDetailsModal = __decorate([
        inject('store'),
        observer
    ], HygienesDetailsModal);
    return HygienesDetailsModal;
}(React.Component));
export { HygienesDetailsModal };
